import React, { useEffect, useState } from 'react';
import { Link, NavLink, useLocation } from 'react-router-dom';
import mark from '../../assets/safehand-mark.png';
import { useLang } from '../../i18n/LanguageContext';
import { PARTNER_LINK } from '../SafeHand/Sections';

export default function Navbar() {
  const { t, toggle } = useLang();
  const [open, setOpen] = useState(false);
  const [scrolled, setScrolled] = useState(false);
  const { pathname } = useLocation();

  useEffect(() => setOpen(false), [pathname]);

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 8);
    onScroll();
    window.addEventListener('scroll', onScroll, { passive: true });
    return () => window.removeEventListener('scroll', onScroll);
  }, []);

  useEffect(() => {
    document.body.classList.toggle('nav-open', open);
    return () => document.body.classList.remove('nav-open');
  }, [open]);

  const links = [
    { to: '/safehand', label: t.nav.safehand },
    { to: '/services', label: t.nav.studio },
    { to: '/portfolio', label: t.nav.work },
    { to: '/about', label: t.nav.about },
    { to: '/faq', label: t.nav.faq },
    { to: '/contact', label: t.nav.contact },
  ];

  return (
    <header className={`site-nav ${scrolled ? 'is-scrolled' : ''} ${open ? 'is-open' : ''}`}>
      <div className="container site-nav__inner">
        <Link to="/" className="brand" aria-label="SafeHand — home">
          <img src={mark} alt="" width="36" height="36" />
          <span className="brand__text">
            <strong>SafeHand</strong>
            <small>by Safe Hand Apps</small>
          </span>
        </Link>

        <nav id="primary-nav" className="site-nav__links" aria-label="Primary">
          {links.map((l) => (
            <NavLink key={l.to} to={l.to} className={({ isActive }) => `nav-link ${isActive ? 'is-active' : ''}`}>
              {l.label}
            </NavLink>
          ))}
          <div className="site-nav__mobile-actions">
            <button type="button" className="lang-btn" onClick={toggle}>
              <i className="fa-solid fa-language" aria-hidden="true" /> {t.nav.langSwitch}
            </button>
            <Link to={PARTNER_LINK} className="btn btn--primary btn--block">
              {t.nav.cta}
            </Link>
          </div>
        </nav>

        <div className="site-nav__actions">
          <button type="button" className="lang-btn" onClick={toggle} lang={t.nav.langSwitch === 'English' ? 'en' : 'ar'}>
            {t.nav.langSwitch}
          </button>
          <Link to={PARTNER_LINK} className="btn btn--primary btn--sm">
            {t.nav.cta}
          </Link>
        </div>

        <button
          type="button"
          className="burger"
          aria-label={t.nav.menu}
          aria-expanded={open}
          aria-controls="primary-nav"
          onClick={() => setOpen((o) => !o)}
        >
          <i className={`fa-solid ${open ? 'fa-xmark' : 'fa-bars'}`} aria-hidden="true" />
        </button>
      </div>
    </header>
  );
}
